var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-mobile-image"},[_c('picture',[(_vm.index === 0)?_c('img',{staticClass:"slider-image",attrs:{"width":"600","height":"400","alt":_vm.image.description,"src":_vm.getContentfulImgURL({
          url: _vm.image.url,
          width: 600,
          height: 400,
          quality: 90,
          fit: 'pad',
          bgColor: 'rgb:000000'
        })}}):_c('img',{staticClass:"slider-image lazyload",attrs:{"width":"600","height":"400","alt":_vm.image.description,"data-src":_vm.getContentfulImgURL({
          url: _vm.image.url,
          width: 600,
          height: 400,
          quality: 90,
          fit: 'pad',
          bgColor: 'rgb:000000'
        })}})]),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.image.title)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }